<template>
  <v-bottom-sheet>
    <template v-slot:activator="{ on }">
      <v-btn
        small
        color="info"
        v-on="on"
      >
        Restore
      </v-btn>
    </template>

    <v-sheet
      class="text-center"
      height="100px"
    >
      <div class="py-3">
        Are you sure you want to restore <b>{{ payrollCycle.code.toUpperCase() }}</b>? 
      </div>

      <v-btn
        :loading="progressing"
        color="hrissecondary"          
        class="white--text px-10"
        @click="submitForm"
      >
        Yes
      </v-btn>
    </v-sheet>
  </v-bottom-sheet> 
</template>

<script>
  export default {
    props: {
      payrollCycle: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true
        
        this.$api.hrisPayrollCycles().restore(this.payrollCycle.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('restored')
              this.$snack({ message: response.data.status })
              this.menu = false
            }
          })
          .catch((err) => {
            if (err.response.status === 500) {              
              this.$snack({ 
                color: 'error',
                message: err.response.data.status, 
              })
            }
          })
          .then(() => {
            this.progressing = false
          })
      },
    },
  }
</script>
